
export default {
  name: 'GraduateCard',
  props: {
    image: { type: String, required: true },
    alt: { type: String, required: true },
    title: { type: String, required: true },
    description: { type: String, required: true },
    course: { type: String, default: '120-hour Premier Online TEFL Course' },
    stars: { type: Number, default: 5, validator: (value) => value >= 0 && value <= 5 },
    bg: { type: String, default: '#309DB6' } 
  }
};
